export default "__VITE_ASSET__CPbU9ZfN__"